/***********************
 * Minimal Utils
 ***********************/
const personalizeUtils = {
  FormatStringWithUnderscore(str) {
    if (!str) return "";
    return str.toLowerCase().replace(/ /g, "_");
  },

  RedirectToCustomization(type, brand, model, color) {
    let url = "/pages/customization?";

    if (type) url += `type=${this.FormatStringWithUnderscore(type)}&`;
    if (brand) url += `brand=${this.FormatStringWithUnderscore(brand)}&`;
    if (model) url += `model=${this.FormatStringWithUnderscore(model)}&`;
    if (color) url += `color=${this.FormatStringWithUnderscore(color)}&`;

    window.location.href = url;
  },

  SetUrlParams(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, this.FormatStringWithUnderscore(value));
    window.history.pushState({}, "", url);
  },
};

/***********************
 * Brand Modal
 ***********************/
function openBrandSelectionModal(items, title) {
  const brandListTemplate = items
    .filter(item => item?.availability ?? true)
    .map(item => {
      const altName = personalizeUtils.FormatStringWithUnderscore(item.title);
      return `
        <li>
          <img
            src="${item.image_url}"
            alt="${altName}"
            class="brand-option-img"
            data-item='${JSON.stringify(item)}'
            data-title="${title}"
          />
        </li>
      `;
    })
    .join("");

  const wrapper = `<ul class="brand-list">${brandListTemplate}</ul>`;

  openModelContainer(wrapper, "customization-brand-list", title, true);

  // Event delegation
  document
    .querySelector(".brand-list")
    ?.addEventListener("click", onBrandClick);
}

/***********************
 * Brand Click Handler
 ***********************/
function onBrandClick(e) {
  const img = e.target.closest(".brand-option-img");
  if (!img) return;

  const item = JSON.parse(img.dataset.item);
  const title = img.dataset.title;

  openModelOption(item, item.title, title);
}

/***********************
 * Model Modal
 ***********************/
function openModelOption(selectedItem, selectedBrand, productType) {
  const modelItems = selectedItem.items;

  if (!modelItems || modelItems.length === 0) {
    return personalizeUtils.RedirectToCustomization(
      productType,
      selectedBrand,
      null,
      null
    );
  }

  personalizeUtils.SetUrlParams("brand", selectedBrand);

  const modelListTemplate = modelItems
    .filter(item => item?.availability ?? true)
    .map(item => {
      const altName = personalizeUtils.FormatStringWithUnderscore(item.title);
      const imageUrl = item.image_url;

      const redirect = () =>
        personalizeUtils.RedirectToCustomization(
          productType,
          selectedBrand,
          item.title,
          null
        );

      if (imageUrl) {
        return `
          <li>
            <img
              src="${imageUrl}"
              alt="${altName}"
              class="brand-option-img"
              data-redirect="true"
              data-model="${item.title}"
              data-brand="${selectedBrand}"
              data-type="${productType}"
            />
          </li>
        `;
      }

      return `
        <li
          class="phone-model-list"
          data-redirect="true"
          data-model="${item.title}"
          data-brand="${selectedBrand}"
          data-type="${productType}"
        >
          ${item.title}
        </li>
      `;
    })
    .join("");

  const wrapper = `<ul class="model-list scroll-container">${modelListTemplate}</ul>`;

  openModelContainer(
    wrapper,
    "customization-phone-model",
    selectedBrand,
    true
  );

  document
    .querySelector(".model-list")
    ?.addEventListener("click", onModelClick);
}

/***********************
 * Model Click Handler
 ***********************/
function onModelClick(e) {
  const el = e.target.closest("[data-redirect]");
  if (!el) return;

  personalizeUtils.RedirectToCustomization(
    el.dataset.type,
    el.dataset.brand,
    el.dataset.model,
    null
  );
}

/***********************
 * Personalize Button
 ***********************/
document
  .getElementById("personalizeLink")
  ?.addEventListener("click", async function (e) {
    const productType = this.dataset.productType;
    const productSubType = this.dataset.productSubType;

    if (productType !== "Smartphone Cover") return;

    e.preventDefault();

    try {
      const response = await fetch('https://s3.ap-south-1.amazonaws.com/myxtur2.0/Prod/Additional-Files/custom_product_navigation.json');
      const data = await response.json();
      const currentObj = data?.find(item => item.title === productSubType);
      if (!productSubType || !currentObj) return;

      openBrandSelectionModal(currentObj?.items, productSubType);
    } catch (err) {
      console.error("Failed to load customization data", err);
    }
  });